import { formatDate } from '@dhl/utils'

export const presentDateOrDefault = (date: string | undefined | null, defaultValue = '-') =>
  date ? formatDate(date) : defaultValue
